<p-dialog
  [(visible)]="chunkNotFoundDialogService.visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="tw:w-[30rem]">
  <div class="tw:flex tw:flex-col tw:gap-3 tw:items-center">
    <img
      alt="Refresh Required"
      ngSrc="assets/images/svg/oh-snap.svg"
      priority
      [width]="139"
      [height]="130" />
    <div class="tw:font-bold tw:text-4xl">Refresh Required!</div>
    <div class="tw:text-center">Please refresh the page to see the latest updated sandbox</div>
  </div>

  <ng-template pTemplate="footer">
    <div class="tw:flex tw:flex-auto tw:justify-center tw:my-2">
      <p-button
        test-id="chunk-not-found-dialog-refresh-page"
        [buttonProps]="{ autofocus: false }"
        icon="pi pi-sync"
        label="Refresh page"
        (click)="reloadPage()" />
    </div>
  </ng-template>
</p-dialog>
